(function($){
	$(document).ready(function(){
      
		function resizeToggle(){
	      if($(window).width() < 940){
	        $(".link-lists").css("display", "none");
//             $('.zoomContainer').remove();  
//             $.removeData($(".image-main.cycle-slide-active"), 'elevateZoom');
//             $(".image-main.cycle-slide-active").removeData("elevateZoom"); 
//             alert("ey")
	      } else if ($(window).width() < 768){
		        $(".product-slider").flickity({
		          	groupCells: false,
                  	prevNextButtons: false
		        })
	      } else if ($(window).width() < 480){
				$("#cross-sells.cross-sell").flickity({
                    arrowShape: { 
                      x0: 10,
                      x1: 70, y1: 40,
                      x2: 70, y2: 25,
                      x3: 30
                    },
                    contain: true,
                    freeScroll: true,          
                    pageDots: false,
                    imagesLoaded: true
                })
	      }
	      else{
	      	$(".link-lists").removeAttr("style");
	      	$(".sub-contents").removeAttr("style");
            $("#cross-sells.cross-sell").removeClass('product-slider')

	      }
		}

		resizeToggle();

		$(".locator_arrow").click(function(){
			var $this = $(this),
				parent = $this.closest(".today_schedule"),
				scheds = parent.siblings(".all_schedule");

				scheds.slideToggle(500);
				if($this.hasClass("dropped")){
					$this.removeClass("dropped");
				}
				else{
					$this.addClass("dropped");
				}
		})

		$(".arrow-drop").click(function(){
			var $this = $(this),
				$subcont = $this.siblings(".sub-contents"),
				$liParent = $this.closest("li"),
				$liSibling = $liParent.siblings("li"),
				$cousSub = $liSibling.find("sub-contents"),
                $liParent = $this.closest("ul.navigation")


			$subcont.slideToggle(500);	
			if($this.hasClass("on-drop")){
				$this.removeClass("on-drop");
              	$liParent.removeClass("overflowed");
			}else{
				$this.addClass("on-drop");
              	$liParent.addClass("overflowed");
			}
		})
        
        $(".list-header").click(function(){
        	var $this = $(this),
        		$linkList = $this.siblings(".link-lists");

//         	$linkList.slideToggle(500);
          	$this.next().slideToggle(500);
        })
		$(".menu-btn").click(function(){
			$(".nav-container").animate({left: 0}, 500);
			// $("#black-cover").addClass("active");
			$("#black-cover").fadeIn(500);
		});
		$("#black-cover").click(function(){
			var menuWid = -Math.abs(parseFloat($(".nav-container").width()));
			// $(".nav-container").animate({left: -Math.abs(menuWid)});
			$(".nav-container").animate({left: menuWid}, 500);
			// $("#black-cover").removeClass("active");
			$("#black-cover").fadeOut(500);			
		})
		$(window).resize(function(){
			var menuWid = -Math.abs(parseFloat($(".nav-container").width()));
			$(".nav-container").css({"left": menuWid})
			resizeToggle();
		})

		$(".details-shipping .div-buttons .ds-btns").click(function(e){
			e.preventDefault();
			var $this = $(this),
				$siblings = $this.siblings(".ds-btns"),
				$parent = $this.parent(),
				$detailCont = $parent.siblings(".details-content"),
				$shipCont = $parent.siblings(".ship-content");

			if(!$this.hasClass("active") && $this.hasClass("details")){
				$this.addClass("active");
				$siblings.removeClass("active");

				$detailCont.removeClass("non-visib");
				$detailCont.addClass("visib");
				$shipCont.removeClass("visib");
				$shipCont.addClass("non-visib");
			}
			else if(!$this.hasClass("active") && $this.hasClass("ship")){
				$this.addClass("active");
				$siblings.removeClass("active");

				$shipCont.removeClass("non-visib");
				$shipCont.addClass("visib");
				$detailCont.removeClass("visib");
				$detailCont.addClass("non-visib");
			}


		})	

		$("#search-drop").click(function(e){
			e.preventDefault();

			$("#search-bar").slideToggle(500);
		});

		$(".search-bind").click(function(){ $(this).submit() })

		function radioPicker(this1){
			var $this = this1,
				sibs = $this.siblings();

			if(!$this.hasClass("selected") && !$this.hasClass("disabled")){
				$this.addClass("selected")
				sibs.removeClass("selected");
			}
		}

		$(".size-container .swatch-btn.sz").click(function(){
			radioPicker($(this))
		})
		$(".color-container .swatch-btn.clr").click(function(){
			radioPicker($(this))
		})


		$(".password-bind").click(function(e){
			e.preventDefault();
			var $this = $(this),
				$loginBlock = $this.closest(".form-block.login"),
				$loginHead = $loginBlock.siblings(".login-header"),
				$passHead = $loginBlock.siblings(".pr-header"),
				$passBlock = $loginBlock.siblings(".form-block.pass-recov");

				$loginBlock.slideToggle(500);
				$loginHead.slideToggle(500);
				$passHead.slideToggle(500);
				$passBlock.slideToggle(500);
		})
        
        
        $('#search-bar .search-bind').click(function(){ $(this).closest('.search').trigger('submit') })
        
        $(".center-slider").flickity({
            arrowShape: { 
              x0: 10,
              x1: 70, y1: 40,
              x2: 70, y2: 25,
              x3: 30
            },
          	imagesLoaded: true,
          	prevNextButtons: false,
          	autoPlay: 5000,
          	setGallerySize: false,
          	lazyLoad: true
        })
        $(".mobglobal-slider").flickity({
            arrowShape: { 
              x0: 10,
              x1: 70, y1: 40,
              x2: 70, y2: 25,
              x3: 30
            },
          	imagesLoaded: true,
          	prevNextButtons: false,
          	autoPlay: 5000,
          	lazyLoad: true
        })
        $(".product-slider, .product-slider.markdown, .product-slider-related").flickity({
            arrowShape: { 
              x0: 10,
              x1: 60, y1: 50,
              x2: 70, y2: 40,
              x3: 30
            },
          	contain: true,
          	freeScroll: true,          
          	pageDots: false,
          	imagesLoaded: true
        })
        
        var instaFeed = new Instafeed({
        get: 'user',
        userId: '350278468',
        limit: 4,
        resolution: 'standard_resolution',
//         accessToken: '350278468.1677ed0.ee851b8d1d1042ae8b3fa4db02b9a456',
        accessToken: '350278468.1677ed0.f377f3d1e95d41cbae83103da08fda4d',
        sortBy: 'most-recent',
        template: '<a href="\{\{link\}\}" target="_blank"><img src="\{\{image\}\}" alt=""></a>'
        });
      
        if($('body').hasClass('template-index')){
            instaFeed.run();
        }
        
        const observer = lozad(); // lazy loads elements with default selector as '.lozad'
        observer.observe();    
      
      
        function signUpValidate(privPolBox, Fname, lName, email, pass, e){
            if(privPolBox.prop('checked') == true && Fname.val() != '' && lName.val() != '' && email.val() != '' && pass.val() != ''){
            }
            else if(privPolBox.prop('checked') == false){
                e.preventDefault()
                alert("You need to comply to our Privacy Policies in order to register.")
            }
            else{
                e.preventDefault()
                alert("Please leave no form blank.")
            }	
        }


        $('#FirstName, #LastName, #Email, #CreatePassword').keypress(function(e){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            var $this = $(this),
                formParent = $this.closest('form'),
                privPolBox = formParent.find('input[type="checkbox"]'),
                Fname = formParent.find('#FirstName'),
                lName = formParent.find('#LastName'),
                email = formParent.find('#Email'),
                pass = formParent.find('#CreatePassword')


            if( keycode == 13){
                signUpValidate(privPolBox, Fname, lName, email, pass, e);
            }

        })

        $('#sign-up-btn').click(function(e){
            var $this = $(this),
                formParent = $this.closest('form'),
                privPolBox = formParent.find('input[type="checkbox"]'),
                Fname = formParent.find('#FirstName'),
                lName = formParent.find('#LastName'),
                email = formParent.find('#Email'),
                pass = formParent.find('#CreatePassword')

                signUpValidate(privPolBox, Fname, lName, email, pass, e);	
        })
        $(".block-collapsible-nav-title").click(function(){
        	var $this = $(this),
                $content = $this.siblings('.content');

          	$content.slideToggle();
        })
        
        function emailSubmit(formval, privpol){
          var chimpForm = $('#mc-embedded-subscribe-form'),
              formInput = chimpForm.find('#mce-EMAIL'),
              subsValue = formval,
              privacyTick = privpol;
				
          if(privacyTick.prop('checked')){ 
            formInput.val(subsValue)
            chimpForm.trigger("submit");
          }
          else{
           	alert('Please agree to the terms of the Privacy Policy') 
          }
        }

        $('#subscribe-form').submit(function(e){
          e.preventDefault();
          var $this = $(this),
              $inputVal = $this.find("#input-email-submit").val(),
              $privacyTick = $this.find("#mail-privacy")

              emailSubmit($inputVal, $privacyTick)
        })


        $('#subscribe-form .btn-submit').click(function(e){
          e.preventDefault();
          var $this = $(this),
              $inputVal = $this.siblings("#input-email-submit").val(),
          	  $privacyTick = $this.closest("form").find("#mail-privacy")

              emailSubmit($inputVal, $privacyTick)
        })
        

        
        if(location.pathname == '/account/login' & (location.hash == '#forgot' || location.hash == '#recover')){
          $('a.black-link.password-bind').trigger('click')
        }
	
//      var ezAPI = $(".image-main.cycle-slide-active").data('elevateZoom');
//      var mq = window.matchMedia('(min-width: 768px)');
//       mq.addListener((b) => {
//         if (b.matches) {
//             // do something for screens > 768px, for example turn on zoom
//             ezAPI.changeState('enable');
//         } else {
//             // do something for screens < 768px, for example turn off zoom
//             $.removeData($(".image-main.cycle-slide-active"), 'elevateZoom');
//             $('.zoomContainer').hide();
//         }
//       });      
      
        
	})
})(jQuery)